<template>
    <div style="width: 100%;">
        <div style="width: 100%;">
            <div
                style="width: 100%;height:50px;text-align: center;font-size: 25px;font-weight: 600;color: #409EFF;margin-top: 30px;">
                {{ voteData.pvmTitle || '投票' }}
            </div>
            <div style="width: 100%;display: flex;flex-direction: column;align-items: center;margin-top: 20px;">
                <div
                    style="width: 90px;height: 90px;border-radius: 100%;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);">
                    <el-image style="width: 100%; height: 100%" :src="data.pmuHeader" fit="fill"></el-image>
                </div>
                <div
                    style="width: 100%;text-align: center;font-size: 18px;font-weight: 600;color: #409EFF;margin-top: 20px;">
                    欢迎您! {{ data.pmuDepartment }} ---- {{ data.pmuName }}
                </div>
                <div
                    style="width: 100%;text-align: center;font-size: 18px;font-weight: 600;color: #F56C6C;margin-top: 20px;">
                    您最多投 {{ voteData.pvmTypeMultiMax }}票
                </div>
            </div>

            <div
                style="width: 90%;margin: 15px auto;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);overflow-y: auto;height: 280px;">
                <el-checkbox-group v-model="checkboxGroup1" size="medium" :max="voteData.pvmTypeMultiMax">
                    <div style="width: 100%;" v-for="(item, index) in voteData.pzVoteItemList || []" :key="index">
                        <div style="width: 100%;margin: 10px 0;">
                            <el-checkbox style="width: 100%;" :label="item.pviId" border>{{ item.pviValue
                                }}</el-checkbox>
                        </div>
                    </div>
                </el-checkbox-group>
            </div>
            <div style="text-align: center;">
                <el-button type="success" style="width: 100%;" @click="toSubmit()">提交</el-button>
            </div>
        </div>

        <!-- 登录 -->
        <div style="width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.5);
        position: fixed;top: 0;display: flex;align-items: center;justify-content: center;left: 0;" v-if="userLogin">
            <div style="width: 60%;height: 50%;background-color: white;border-radius: 23px;padding: 30px;">
                <div style="width: 100%;margin: 15px auto;font-size: 18px;color: #409EFF;text-align: center;">登录</div>
                <el-form ref="form" :model="form" label-position="left" style="height:100%" size="mini">
                    <el-form-item label="姓名">
                        <el-input v-model="form.pmuName" style="width: 100%;height: 50px;" placeholder="请输入"
                            size="medium"  clearable></el-input>
                    </el-form-item>
                    <div style="margin: 5px auto;width: 60%;">
                        <el-button type="success" round @click="gotoLogin">下一步</el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>

import {
    getPzMainUserLogin, addPzVoteRecord
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            checkboxGroup1: [],
            voteData: '',
            data: '',
            userLogin: true,
            isvote: false,
            form: {
                pvmId: '',
                pmuName: '',
            },
        };
    },
    activated() {

    },
    watch: {

    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        
        this.form.pvmId = this.getQueryParam('https://prizeback.aojuai.com/#/voteUser?pvmId=3').pvmId;
        localStorage.setItem('pvmId', this.form.pvmId);
        console.log(this.form.pvmId);
    },
    mounted() { },
    methods: {
        toSubmit() {
            this.$confirm("是否确定投票,后续无法修改 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const s = {
                        pvmId: this.form.pvmId,
                        pmuId: this.data.pmuId,
                        pviIds: JSON.stringify(this.checkboxGroup1)
                    }
                    addPzVoteRecord(s).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: "投票成功!",
                            });
                            this.$router.push({
                                path: '/votePaiHang',
                                query: {
                                    pvmId: this.voteData.pvmId,
                                }
                            })
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        gotoLogin() {
            getPzMainUserLogin(this.form).then(res => {
                this.userLogin = false;
                this.data = res.data;
                this.voteData = res.item;
                this.voteData.pvmTypeMultiMax = res.item.pvmTypeMultiMax * 1
                this.voteData.pvmTypeMultiMin = res.item.pvmTypeMultiMin * 1;
                document.title = res.item.pvmTitle;
                localStorage.setItem('pmuId', res.data.pmuId);
                if (res.item.pzVoteRecordList && res.item.pzVoteRecordList.length > 0) {
                    this.$router.push({
                        path: '/votePaiHang',
                        query: {
                            pvmId: this.voteData.pvmId,
                        }
                    })
                }
            })
        },
        getQueryParam(url) {
            var query = url.split('?')[1];
            var params = {};
            if (query) {
                var pairs = query.split('&');
                pairs.forEach(function (pair) {
                    var parts = pair.split('=');
                    params[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
                });
            }
            return params;

        }
    }
};
</script>

<style>
div .el-radio--medium.is-bordered {
    width: 100% !important;
    height: auto !important;
    padding: 5px 15px !important;
}

div .el-radio {
    white-space: inherit !important;
    line-height: 2 !important;
}

div .el-input--medium .el-input__inner {
    min-height: 10vw !important;
    line-height: 10vw !important;
    font-size: 0.6rem !important;
    text-align: center !important;
}

div .el-form-item__label {
    font-size: 0.6rem !important;
    padding: 10px 10px !important
}

div .el-button.is-round {
    border-radius: 9.667vw !important;
    padding: 2.6vw 8.067vw !important;
}

.labelStyle {
    color: red;
}

.el-message-box {
    width: 80%;
}

.disUoloadSty .el-upload--picture-card {
    display: none;
    /* 上传按钮隐藏 */
}

.el-upload--picture-card {
    width: 100%;
}

.el-upload-list--picture-card .el-upload-list__item {
    width: 100%;
}

html {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    margin: 0;
    padding: 0;

}

body {
    width: 100vw;
    margin: 0;
    padding: 10px;
    box-sizing: border-box;
}
</style>